import * as React from 'react';
import { forwardRef, useEffect, useState } from 'react';
import ClickToEdit from 'react-click-to-edit';

const roleMapping = {
  delegate: 'Delegate',
  exhibitor: 'Exhibitor',
  speaker: 'Speaker',
  superadmin: 'Organiser',
  faculty: 'Faculty',
};

export const PrintContent = React.forwardRef<HTMLDivElement, any>(
  (props, ref) => {
    const { user, setEditMode } = props;
    const { fullName, organisation, role, qrLabel } = user;

    const renderField = (value, className = '') => (
      <ClickToEdit
        wrapperClass={`line ${className}`}
        initialValue={value}
        startEditing={() => {
          setEditMode(true);
        }}
        endEditing={() => {
          setEditMode(false);
        }}
      />
    );

    return (
      <div ref={ref} className="print-container">
        <div className="print-text">
          {/* <div className="imageGap"></div> */}
          {renderField(fullName, 'fullName')}
          {renderField(roleMapping[role], 'role')}
          {renderField(organisation, 'organisation')}
          {/* <img id="qrLabel" src={qrLabel} /> */}
        </div>
      </div>
    );
  }
);

// const PrintContent = forwardRef(PrintContentRef)
export default PrintContent;
